module.exports = __webpack_public_path__ + "static/media/linkedin.a84ea928.svg";